import React, { useEffect, useRef, useState } from 'react';

const MIN_S = 30;
const MAX_S = 90;
const TIPOS = ['video/mp4;codecs=avc1.42E01E,mp4a.40.2', 'video/mp4', 'video/webm;codecs=vp8,opus', 'video/webm'];

export default function GrabadorVerificacion({ guion, onGrabado, onCerrar }) {
  const videoRef = useRef(null);
  const guionRef = useRef(null);
  const streamRef = useRef(null);
  const recRef = useRef(null);
  const chunksRef = useRef([]);
  const t0Ref = useRef(0);
  const timerRef = useRef(null);
  const autoRef = useRef(true);
  const canceladoRef = useRef(false);
  const [estado, setEstado] = useState('iniciando');
  const [seg, setSeg] = useState(0);
  const [error, setError] = useState('');

  const apagar = () => {
    clearInterval(timerRef.current);
    const r = recRef.current;
    if (r && r.state !== 'inactive') { try { r.stop(); } catch (e) {} }
    if (streamRef.current) streamRef.current.getTracks().forEach((t) => t.stop());
  };

  useEffect(() => {
    let activo = true;
    const abrir = async () => {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
        setError('Este navegador no permite grabar dentro de la pagina. Abre ulalaaa.com en Chrome o Safari, o usa SUBIR DESDE GALERIA.');
        setEstado('error');
        return;
      }
      try {
        const s = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'user', width: { ideal: 1280, max: 1280 }, height: { ideal: 720, max: 1280 }, frameRate: { ideal: 30 } },
          audio: true,
        });
        if (!activo) { s.getTracks().forEach((t) => t.stop()); return; }
        streamRef.current = s;
        if (videoRef.current) videoRef.current.srcObject = s;
        setEstado('listo');
      } catch (e) {
        setError('No se pudo abrir la camara y el microfono. Revisa los permisos de este sitio en tu navegador.');
        setEstado('error');
      }
    };
    abrir();
    return () => { activo = false; canceladoRef.current = true; apagar(); };
  }, []);

  useEffect(() => {
    if (estado !== 'grabando') return undefined;
    const id = setInterval(() => {
      const el = guionRef.current;
      if (!el || !autoRef.current) return;
      const total = el.scrollHeight - el.clientHeight;
      el.scrollTop = Math.min(total, total * ((Date.now() - t0Ref.current) / 70000));
    }, 100);
    return () => clearInterval(id);
  }, [estado]);

  const finalizar = (mime) => {
    if (canceladoRef.current) return;
    const dur = (Date.now() - t0Ref.current) / 1000;
    const base = (mime || 'video/webm').split(';')[0];
    const ext = base.indexOf('mp4') >= 0 ? 'mp4' : 'webm';
    const file = new File([new Blob(chunksRef.current, { type: base })], 'verificacion.' + ext, { type: base });
    file.duracionGrabada = dur;
    if (streamRef.current) streamRef.current.getTracks().forEach((t) => t.stop());
    onGrabado(file);
  };

  const parar = () => {
    clearInterval(timerRef.current);
    const r = recRef.current;
    if (r && r.state !== 'inactive') r.stop();
  };

  const iniciar = () => {
    const tipo = TIPOS.find((t) => window.MediaRecorder.isTypeSupported && window.MediaRecorder.isTypeSupported(t)) || '';
    let rec;
    try {
      rec = new window.MediaRecorder(streamRef.current, tipo ? { mimeType: tipo, videoBitsPerSecond: 2500000 } : { videoBitsPerSecond: 2500000 });
    } catch (e) {
      setError('Este navegador no puede grabar video aqui. Usa SUBIR DESDE GALERIA.');
      setEstado('error');
      return;
    }
    chunksRef.current = [];
    rec.ondataavailable = (ev) => { if (ev.data && ev.data.size > 0) chunksRef.current.push(ev.data); };
    rec.onstop = () => finalizar(rec.mimeType || tipo);
    recRef.current = rec;
    t0Ref.current = Date.now();
    rec.start(1000);
    setSeg(0);
    setEstado('grabando');
    timerRef.current = setInterval(() => {
      const t = Math.floor((Date.now() - t0Ref.current) / 1000);
      setSeg(t);
      if (t >= MAX_S) parar();
    }, 250);
  };

  const cancelar = () => { canceladoRef.current = true; apagar(); onCerrar(); };
  const faltan = Math.max(0, MIN_S - seg);
  const btn = { padding: '12px 22px', fontSize: 16, fontWeight: 'bold', border: 'none', borderRadius: 8, cursor: 'pointer', margin: '0 6px' };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: '#000', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: '1 1 45%', minHeight: 0, position: 'relative' }}>
        <video ref={videoRef} autoPlay muted playsInline style={{ width: '100%', height: '100%', objectFit: 'contain', transform: 'scaleX(-1)' }} />
        {estado === 'grabando' && (
          <div style={{ position: 'absolute', top: 10, left: 10, background: '#c00000', color: '#fff', padding: '4px 10px', borderRadius: 6, fontWeight: 'bold' }}>
            REC {seg}s / {MAX_S}s
          </div>
        )}
      </div>
      <div
        ref={guionRef}
        onTouchStart={() => { autoRef.current = false; }}
        onWheel={() => { autoRef.current = false; }}
        style={{ flex: '1 1 40%', overflowY: 'auto', background: 'rgba(20,20,20,0.95)', color: '#fff', padding: 14, fontSize: 19, lineHeight: 1.5, fontFamily: 'Arial, sans-serif' }}
      >
        {guion}
      </div>
      <div style={{ flex: '0 0 auto', textAlign: 'center', padding: 10, background: '#111' }}>
        {error && <p style={{ color: '#ff8a8a', margin: '0 0 8px' }}>{error}</p>}
        {estado === 'listo' && <button style={{ ...btn, background: '#c00000', color: '#fff' }} onClick={iniciar}>INICIAR GRABACION</button>}
        {estado === 'grabando' && (
          <button style={{ ...btn, background: faltan > 0 ? '#555' : '#2e7d32', color: '#fff' }} disabled={faltan > 0} onClick={parar}>
            {faltan > 0 ? 'Faltan ' + faltan + ' s para terminar' : 'TERMINAR'}
          </button>
        )}
        {estado === 'iniciando' && <span style={{ color: '#ccc' }}>Abriendo camara...</span>}
        <button style={{ ...btn, background: '#333', color: '#fff' }} onClick={cancelar}>CANCELAR</button>
      </div>
    </div>
  );
}
